// src/composables/useInvoiceCalculations.js
import { ref, computed, watch } from 'vue'

export default function useInvoiceCalculations(tableItemsRef, totals) {
    const discountAmount = ref(0)
    const discountPercent = ref(0)
    const grandTotal = ref(0)

    // Helper: return safe array
     const itemDetails = computed(() => Array.isArray(tableItemsRef.value) ? tableItemsRef.value : [])

    const subTotal = computed(() => {
        if (!itemDetails.value.length) {
            totals.value.subTotalVal = 0
            return 0
        }

        const total = itemDetails.value.reduce((sum, item) => {
            const qty = parseFloat(item.quantity || 0)
            const rate = parseFloat(item.rate || 0)
            const discount = parseFloat(item.discount_amount || 0)
            const vat = parseFloat(item.vat_amount || 0)
            return sum + (qty * rate - discount + vat)
        }, 0)

      totals.value.subTotalVal = total.toFixed(4)
      return parseFloat(total.toFixed(4))
    })

    const totalVAT = computed(() => {
        if (!itemDetails.value.length) {
            totals.value.totalVatVal = 0
            return 0
        }

        const vat = itemDetails.value.reduce((sum, item) => sum + parseFloat(item.vat_amount || 0), 0)
        totals.value.totalVatVal = vat.toFixed(4)
        return parseFloat(vat.toFixed(4))
    })

    const totalDiscount = computed(() => {
        if (!itemDetails.value.length) return 0
        const discount = itemDetails.value.reduce((sum, item) => sum + parseFloat(item.discount_amount || 0), 0)
        return parseFloat(discount.toFixed(4))
    })

    const total = computed(() => {
        const totalValue = parseFloat(subTotal.value) + parseFloat(totalVAT.value)
        totals.value.totalVal = totalValue.toFixed(4)
        return parseFloat(totalValue.toFixed(4))
    })

      const getAmountAfterDiscount = computed(() => {
            let discount = 0;
            itemDetails.value.map(item => {
                if(item.discount_amount) {
                    discount += parseFloat(item.discount_amount);
                }
            })
            return discount.toFixed(4);
      })

    watch([discountAmount, total], () => {
        grandTotal.value = parseFloat((total.value - discountAmount.value).toFixed(4))
    })

    watch(discountPercent, () => {
        if(discountPercent.value === 0){
            return discountAmount.value = 0;
        } 
        return discountAmount.value = (total.value * discountPercent.value) / 100;
    })

    const setDiscountByPercent = (percent) => {
        discountPercent.value = percent
        discountAmount.value = (total.value * percent) / 100
    }

    const setDiscountAmount = (amount) => {
        discountAmount.value = parseFloat(amount || 0)
        discountPercent.value = total.value > 0
          ? (discountAmount.value / total.value) * 100
          : 0
    }

    const resetDiscounts = () => {
        discountAmount.value = 0
        discountPercent.value = 0
        grandTotal.value = total.value
    }

    return {
        subTotal,
        totalVAT,
        totalDiscount,
        total,
        grandTotal,
        discountAmount,
        discountPercent,
        setDiscountByPercent,
        setDiscountAmount,
        getAmountAfterDiscount,
        resetDiscounts
    }
}
